import { GET_PROFILE_SETTING } from "../../../../Types";

const ProfileSettingReducer = (state = {}, action) => {
  switch (action.type) {
    case GET_PROFILE_SETTING:
      return action.payload;
    default:
      return state;
  }
};
export default ProfileSettingReducer;
